import { Guid, Nillable } from '@web/utils';
import { SubscriptionStatus } from '../../shared/enums';
import { SubscriptionNumber } from '../../shared/types';

export class PublicSubscriptionCollectionItem {
  public constructor(
    private readonly data: {
      canBillingAddressBeUpdated: boolean;
      canShippingAddressBeUpdated: boolean;
      canBeViewed: boolean;
      canBeUpdated: boolean;
      canBeSuspended: boolean;
      canBeResumed: boolean;
      canBeCancelled: boolean;
      id: Guid;
      isLocked: boolean;
      number: SubscriptionNumber;
      status: SubscriptionStatus;
      totalPrice: number;
      nextPaymentDate?: Nillable<Date>;
    },
  ) {}

  public get canBillingAddressBeUpdated(): boolean {
    return this.data.canBillingAddressBeUpdated;
  }

  public get canShippingAddressBeUpdated(): boolean {
    return this.data.canShippingAddressBeUpdated;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeUpdated(): boolean {
    return this.data.canBeUpdated;
  }

  public get canBeSuspended(): boolean {
    return this.data.canBeSuspended;
  }

  public get canBeResumed(): boolean {
    return this.data.canBeResumed;
  }

  public get canBeCancelled(): boolean {
    return this.data.canBeCancelled;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get isLocked(): boolean {
    return this.data.isLocked;
  }

  public get number(): SubscriptionNumber {
    return this.data.number;
  }

  public get status(): SubscriptionStatus {
    return this.data.status;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get nextPaymentDate(): Nillable<Date> {
    return this.data.nextPaymentDate;
  }
}
